import { IconProps } from './IconProps';

export const WeightLoss = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        d="M16.5952 17.7081C17.7155 17.2342 18.5722 16.6484 19.1406 15.9863C18.5655 18.2157 14.8822 20.7267 10.0341 21.9987L9.22946 18.9314C9.3704 18.9341 9.51215 18.936 9.65425 18.936C12.2587 18.936 14.7237 18.4999 16.5952 17.7081Z"
        fill="black"
      />
      <path
        d="M18.222 10.6704V12.1162L17.543 12.533V11.1167C17.017 11.4159 16.3906 11.681 15.6876 11.9062V14.3417L14.8045 14.5502V12.1577C14.3146 12.2798 13.7961 12.3841 13.2537 12.4672V13.6457L12.3703 13.7521V12.5795C11.8436 12.6358 11.3008 12.6747 10.7426 12.6908V15.1751H9.85877V12.6968C9.19252 12.6894 8.54467 12.6527 7.9208 12.5892V13.7521L7.03702 13.6457V12.4814C6.40377 12.3878 5.80433 12.2645 5.24239 12.1177V14.5502L4.35933 14.2355V11.8574C3.75723 11.6564 3.21514 11.4247 2.74811 11.1674V12.533L2.0695 12.1162V10.7383C1.28849 10.1657 0.839844 9.50267 0.839844 8.79492V13.9176C0.839844 14.254 0.9411 14.5808 1.13094 14.8924C2.15766 16.5775 5.78332 17.8228 10.0992 17.8228C10.3378 17.8228 10.5734 17.8177 10.8075 17.8101C15.59 17.6575 19.3586 15.9735 19.3586 13.9176V8.79492C19.3586 9.47461 18.9459 10.1138 18.222 10.6704Z"
        fill="black"
      />
      <mask
        id="mask0_3442_614"
        style={{maskType: 'alpha'}}
        maskUnits="userSpaceOnUse"
        x="1"
        y="-1"
        width="18"
        height="14"
      >
        <path
          d="M18.8965 8.79445C18.8965 10.7121 15.01 12.2667 10.2158 12.2667C5.42162 12.2667 1.53516 10.7121 1.53516 8.79445C1.53516 7.70058 1.53516 -0.00195312 1.53516 -0.00195312C1.53516 -0.00195312 8.15629 -0.00195312 10.2158 -0.00195312C12.3291 -0.00195312 18.8965 -0.00195312 18.8965 -0.00195312C18.8965 -0.00195312 18.8965 7.72209 18.8965 8.79445Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3442_614)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.27967 3.46489L6.98222 4.16745L4.56467 6.58499L3.91552 5.93584C2.36806 8.63917 2.74855 12.1455 5.057 14.4539C7.82102 17.218 12.3024 17.218 15.0664 14.4539C17.8304 11.6899 17.8304 7.20853 15.0664 4.44451C12.6807 2.0588 9.01561 1.73226 6.27967 3.46489ZM4.03397 15.477C0.704942 12.1479 0.704942 6.75051 4.03397 3.42148C7.363 0.0924513 12.7604 0.0924513 16.0894 3.42148C19.4185 6.75051 19.4185 12.1479 16.0894 15.477C12.7604 18.806 7.363 18.806 4.03397 15.477Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.07109 15.3871C2.41801 13.734 1.5976 11.559 1.61088 9.39547C1.62095 7.75445 2.49262 6.47691 3.31248 5.65706L6.22072 2.74881C7.04058 1.92896 8.31811 1.05729 9.95914 1.04722C12.1227 1.03394 14.2977 1.85434 15.9508 3.50742C19.2313 6.78791 19.2313 12.1066 15.9508 15.3871C12.6703 18.6676 7.35157 18.6676 4.07109 15.3871ZM3.78101 9.40879C3.78624 8.5569 4.24463 7.79399 4.84702 7.1916L7.75526 4.28335C8.35765 3.68096 9.12056 3.22257 9.97246 3.21734C11.5797 3.20747 13.19 3.81568 14.4162 5.04196C16.8492 7.47494 16.8492 11.4196 14.4162 13.8526C11.9833 16.2856 8.03861 16.2856 5.60563 13.8526C4.37935 12.6263 3.77114 11.016 3.78101 9.40879Z"
          fill="black"
          fill-opacity="0.5"
        />
      </g>
    </svg>
  );
};
